import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('home');

  const navItems = [
    { name: "Home", href: "/" },
    { name: "Projects", href: "/#projects" },
    { name: "Watches", href: "/watches" },
    { name: "LinkedIn", href: "https://www.linkedin.com/in/joe-skubic/", external: true },
  ];

  // Handle scroll events to update active section
  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname !== '/') {
        setActiveSection('');
        return;
      }

      const sections = ['home', 'about', 'projects', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    if (location.pathname === '/') {
      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Set initial state
    } else {
      setActiveSection('');
    }

    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  // Handle initial navigation with hash
  useEffect(() => {
    if (location.pathname === '/' && location.hash === '#projects') {
      setTimeout(() => {
        const el = document.getElementById('projects');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
          setActiveSection('projects');
        }
      }, 100);
    }
  }, [location.pathname, location.hash]);

  const scrollToSection = (e, href) => {
    if (href === "/#projects") {
      e.preventDefault();
      if (location.pathname !== "/") {
        // Navigate to home first, then scroll to projects
        navigate('/');
        setTimeout(() => {
          const el = document.getElementById("projects");
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
            setActiveSection('projects');
          }
        }, 100);
      } else {
        const el = document.getElementById("projects");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
          setActiveSection('projects');
        }
      }
    } else if (href === "/" && location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
      setActiveSection('home');
    }
  };

  const isActive = (item) => {
    if (item.name === "Home") {
      return location.pathname === "/" && (activeSection === 'home' || activeSection === 'about');
    }
    if (item.name === "Projects") {
      return location.pathname === "/" && activeSection === 'projects';
    }
    if (item.name === "Watches") {
      return location.pathname === "/watches";
    }
    if (item.external) {
      return false;
    }
    return location.pathname === item.href;
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link
          to="/"
          className="nav-logo"
          onClick={(e) => {
            if (location.pathname === "/") {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
              setActiveSection('home');
            } else {
              // Navigate to home page from other pages
              navigate('/');
            }
          }}
        >
          <img src="/images/personal/Skoobs Logo.svg" alt="Skoobs_Logo" className="nav-logo-img" />
          <span className="nav-logo-text">Joe Skubic</span>
        </Link>

        <div className="nav-links">
          {navItems.map((item) => (
            <div key={item.name} className="nav-item">
              {item.external ? (
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`nav-link ${isActive(item) ? 'active' : ''}`}
                >
                  {item.name}
                </a>
              ) : (
                <Link
                  to={item.href}
                  className={`nav-link ${isActive(item) ? 'active' : ''}`}
                  onClick={(e) => scrollToSection(e, item.href)}
                >
                  {item.name}
                </Link>
              )}
              {isActive(item) && <div className="nav-active-indicator" />}
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
